var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "addressModal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "addressModal",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-scrollable modal-lg",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content py-2 px-3 px-md-5" }, [
              _c("div", { staticClass: "modal-header" }, [
                !_vm.addClicked &&
                !_vm.editClicked &&
                !_vm.mellisaValidationModal
                  ? _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "addressModalLabel" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$resourceString["checkout.Address.Modal"]
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.mellisaValidationModal
                  ? _c("h5", { staticClass: "modal-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$resourceString[
                              "checkout.Address.VerifyAddress.Modal"
                            ]
                          ) +
                          "\n          "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.addClicked && !_vm.mellisaValidationModal
                  ? _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "addressModalLabel" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$resourceString[
                                "checkout.Address.NewAddress.Modal"
                              ]
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.editClicked && !_vm.mellisaValidationModal
                  ? _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "addressModalLabel" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$resourceString[
                                "checkout.Address.EditAddress.Modal"
                              ]
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    ref: "closeModal",
                    staticClass: "wf-modal-button-close btn button-full",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close"
                    },
                    on: { click: _vm.exitNewModal }
                  },
                  [
                    _c("span", {
                      staticClass:
                        "png-icon png-icon-icons-symbols--k-txtclose",
                      attrs: { "aria-label": "Close modal" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row d-block d-lg-none" }, [
                  _c("div", { staticClass: "col-12 mb-2" }, [
                    !_vm.addClicked &&
                    !_vm.editClicked &&
                    !_vm.mellisaValidationModal
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wf-add-to-cart-button btn btn-outline-danger justify-content-center w-100",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.addressModalAction(0)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Button.AddNewAddress"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.addClicked || _vm.editClicked
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wf-add-to-cart-button btn btn-outline-danger justify-content-center w-100",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.showAddressList()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.AddressVerification.Modal.AddressList"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                !_vm.addClicked &&
                !_vm.editClicked &&
                !_vm.mellisaValidationModal
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      _vm._l(_vm.addresses, function(address, index) {
                        return _c(
                          "div",
                          {
                            key: address.id,
                            staticClass: "col-12 col-lg-6",
                            attrs: { value: index }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "bg-light p-3 font-24 text-capitalize",
                                class:
                                  index == _vm.addressId
                                    ? "border border-danger rounded"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.addressSelected(index)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "font-weight-bold mb-2" },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(address.company) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "m-0" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(address.firstName) +
                                      " " +
                                      _vm._s(address.lastName) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "m-0" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        address.streetLine2
                                          ? address.streetLine1 +
                                              ", Suite" +
                                              address.streetLine2
                                          : address.streetLine1
                                      ) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "m-0" }, [
                                  _vm._v(
                                    _vm._s(address.city) +
                                      " " +
                                      _vm._s(address.state) +
                                      " " +
                                      _vm._s(address.postalCode)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "m-0" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(address.country) +
                                      "\n                  " +
                                      _vm._s(
                                        address.isDefault
                                          ? " (" +
                                              _vm.$resourceString[
                                                "common.Label.Default"
                                              ] +
                                              ")"
                                          : !_vm.getIsDefaultSelected &&
                                            address.isB2cAddress
                                          ? " (" +
                                            _vm.$resourceString[
                                              "common.Label.Default"
                                            ] +
                                            ")"
                                          : ""
                                      ) +
                                      "                    \n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("hr"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "w-100 mb-3 font-16" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: index == _vm.addressId,
                                            expression: "index == addressId"
                                          }
                                        ],
                                        staticClass: "float-left",
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            return _vm.addressModalAction(1)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$resourceString[
                                                "checkout.AddressVerification.Suggestion.EditButton"
                                              ]
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    !_vm.inputAddress.isDefault &&
                                    !_vm.inputAddress.isB2cAddress &&
                                    index == _vm.addressId
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "float-right",
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                return _vm.removeSelectedUserAddress(
                                                  address.id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$resourceString[
                                                    "checkout.Address.Button.RemoveAddress"
                                                  ]
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("br")
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (_vm.addClicked || _vm.editClicked) &&
                          !_vm.mellisaValidationModal,
                        expression:
                          "(addClicked || editClicked) && !mellisaValidationModal"
                      }
                    ]
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-6 col-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "font-16 font-weight-bold",
                            attrs: { for: "fname" }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.Label.Fname"
                                  ]
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputAddress["firstName"],
                              expression: "inputAddress['firstName']"
                            }
                          ],
                          staticClass:
                            "shipping-modal-input-field form-control",
                          class:
                            _vm.checkoutData.FieldClasses &&
                            _vm.checkoutData.FieldClasses.FirstName
                              ? _vm.checkoutData.FieldClasses.FirstName
                              : "",
                          attrs: {
                            type: "text",
                            id: "fname",
                            name: "fname",
                            placeholder:
                              _vm.$resourceString[
                                "checkout.Address.Placeholder.FirstName"
                              ],
                            required: "",
                            maxlength: "100"
                          },
                          domProps: { value: _vm.inputAddress["firstName"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.inputAddress,
                                "firstName",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.validationError.firstName
                          ? _c("div", { staticClass: "text-danger font-16" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.validationError.firstName) +
                                  "  \n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-6 col-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "font-16 font-weight-bold",
                            attrs: { for: "lname" }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.Label.Lname"
                                  ]
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputAddress["lastName"],
                              expression: "inputAddress['lastName']"
                            }
                          ],
                          staticClass:
                            "shipping-modal-input-field form-control",
                          class:
                            _vm.checkoutData.FieldClasses &&
                            _vm.checkoutData.FieldClasses.FastName
                              ? _vm.checkoutData.FieldClasses.FastName
                              : "",
                          attrs: {
                            type: "text",
                            id: "lname",
                            name: "lname",
                            placeholder:
                              _vm.$resourceString[
                                "checkout.Address.Placeholder.LastName"
                              ],
                            required: "",
                            maxlength: "100"
                          },
                          domProps: { value: _vm.inputAddress["lastName"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.inputAddress,
                                "lastName",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.validationError.lastName
                          ? _c("div", { staticClass: "text-danger font-16" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.validationError.lastName) +
                                  "\n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-6 col-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "font-16 font-weight-bold mt-2",
                            attrs: { for: "country" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$resourceString[
                                  "checkout.Address.Label.Country"
                                ]
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputAddress["country"],
                                expression: "inputAddress['country']"
                              }
                            ],
                            staticClass:
                              "shipping-modal-input-field form-control",
                            class:
                              _vm.checkoutData.FieldClasses &&
                              _vm.checkoutData.FieldClasses.Country
                                ? _vm.checkoutData.FieldClasses.Country
                                : "",
                            attrs: {
                              id: "country",
                              name: "country",
                              required: ""
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.inputAddress,
                                    "country",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  return _vm.countrySelected()
                                }
                              ]
                            }
                          },
                          _vm._l(_vm.countryData, function(country) {
                            return _c(
                              "option",
                              {
                                key: country.Value,
                                domProps: { value: country.Value }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(country.Text) +
                                    "\n                  "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.validationError.country
                          ? _c("div", { staticClass: "text-danger font-16" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.validationError.country) +
                                  "\n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-6 col-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "font-16 font-weight-bold mt-2",
                            attrs: { for: "addressLine1" }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.Label.Address"
                                  ]
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputAddress["streetLine1"],
                              expression: "inputAddress['streetLine1']"
                            }
                          ],
                          ref: "addressLine1",
                          staticClass:
                            "shipping-modal-input-field form-control",
                          class:
                            _vm.checkoutData.FieldClasses &&
                            _vm.checkoutData.FieldClasses.AddressLine1
                              ? _vm.checkoutData.FieldClasses.AddressLine1
                              : "",
                          attrs: {
                            type: "text",
                            id: "addressLine1",
                            name: "addressLine1",
                            placeholder:
                              _vm.$resourceString[
                                "checkout.Address.Placeholder.AddressOne"
                              ]
                          },
                          domProps: { value: _vm.inputAddress["streetLine1"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.inputAddress,
                                "streetLine1",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.validationError.streetLine1
                          ? _c("div", { staticClass: "text-danger font-16" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.validationError.streetLine1) +
                                  "\n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-6 col-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "font-16 font-weight-bold mt-2",
                            attrs: { for: "suite" }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.Label.Suite"
                                  ]
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputAddress["suite"],
                              expression: "inputAddress['suite']"
                            }
                          ],
                          staticClass:
                            "shipping-modal-input-field form-control",
                          class:
                            _vm.checkoutData.FieldClasses &&
                            _vm.checkoutData.FieldClasses.Suite
                              ? _vm.checkoutData.FieldClasses.Suite
                              : "",
                          attrs: {
                            type: "text",
                            id: "suite",
                            name: "suite",
                            placeholder:
                              _vm.$resourceString[
                                "checkout.Address.Placeholder.Suite"
                              ],
                            maxlength: "100"
                          },
                          domProps: { value: _vm.inputAddress["suite"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.inputAddress,
                                "suite",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-6 col-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "font-16 font-weight-bold mt-2",
                            attrs: { for: "city" }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.Label.City"
                                  ]
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputAddress["city"],
                              expression: "inputAddress['city']"
                            }
                          ],
                          staticClass:
                            "shipping-modal-input-field form-control",
                          class:
                            _vm.checkoutData.FieldClasses &&
                            _vm.checkoutData.FieldClasses.City
                              ? _vm.checkoutData.FieldClasses.City
                              : "",
                          attrs: {
                            type: "text",
                            id: "city",
                            name: "city",
                            placeholder:
                              _vm.$resourceString[
                                "checkout.Address.Placeholder.City"
                              ],
                            required: "",
                            maxlength: "100"
                          },
                          domProps: { value: _vm.inputAddress["city"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.inputAddress,
                                "city",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.validationError.city
                          ? _c("div", { staticClass: "text-danger font-16" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.validationError.city) +
                                  "\n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-6 col-12" }, [
                        _c(
                          "label",
                          { staticClass: "font-16 font-weight-bold mt-2" },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.Label.PostalCode"
                                  ]
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputAddress["postalCode"],
                              expression: "inputAddress['postalCode']"
                            }
                          ],
                          staticClass:
                            "shipping-modal-input-field form-control",
                          class:
                            _vm.checkoutData.FieldClasses &&
                            _vm.checkoutData.FieldClasses.PostalCode
                              ? _vm.checkoutData.FieldClasses.PostalCode
                              : "",
                          attrs: {
                            type: "text",
                            id: "pcode",
                            name: "pcode",
                            placeholder:
                              _vm.$resourceString[
                                "checkout.Address.Placeholder.PostalCode"
                              ],
                            required: "",
                            maxlength: "20"
                          },
                          domProps: { value: _vm.inputAddress["postalCode"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.inputAddress,
                                "postalCode",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.validationError.postalCode
                          ? _c("div", { staticClass: "text-danger font-16" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.validationError.postalCode) +
                                  "\n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-6 col-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "font-16 font-weight-bold mt-2",
                            attrs: { for: "stateprovince" }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.Label.State"
                                  ]
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputAddress["state"],
                                expression: "inputAddress['state']"
                              }
                            ],
                            staticClass:
                              "shipping-modal-input-field form-control",
                            class:
                              _vm.checkoutData.FieldClasses &&
                              _vm.checkoutData.FieldClasses.State
                                ? _vm.checkoutData.FieldClasses.State
                                : "",
                            attrs: {
                              id: "stateprovince",
                              name: "stateprovince",
                              required: ""
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.inputAddress,
                                  "state",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          _vm._l(_vm.countryState, function(state) {
                            return _c(
                              "option",
                              {
                                key: state.code,
                                domProps: { value: state.code }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(state.name) +
                                    "\n                  "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.validationError.state
                          ? _c("div", { staticClass: "text-danger font-16" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.validationError.state) +
                                  "\n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-6 col-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "font-16 font-weight-bold mt-2",
                            attrs: { for: "company" }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.Label.Company"
                                  ]
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputAddress["company"],
                              expression: "inputAddress['company']"
                            }
                          ],
                          staticClass:
                            "shipping-modal-input-field form-control",
                          class:
                            _vm.checkoutData.FieldClasses &&
                            _vm.checkoutData.FieldClasses.Company
                              ? _vm.checkoutData.FieldClasses.Company
                              : "",
                          attrs: {
                            type: "text",
                            id: "company",
                            name: "company",
                            placeholder:
                              _vm.$resourceString[
                                "checkout.Address.Placeholder.Company"
                              ],
                            required: "",
                            maxlength: "100"
                          },
                          domProps: { value: _vm.inputAddress["company"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.inputAddress,
                                "company",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.validationError.company
                          ? _c("div", { staticClass: "text-danger font-16" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.validationError.company) +
                                  "\n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-6 col-12" }, [
                        _c(
                          "label",
                          {
                            staticClass: "font-16 font-weight-bold mt-2",
                            attrs: { for: "email" }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.Label.Email"
                                  ]
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputAddress["email"],
                              expression: "inputAddress['email']"
                            }
                          ],
                          staticClass:
                            "shipping-modal-input-field form-control",
                          class:
                            _vm.checkoutData.FieldClasses &&
                            _vm.checkoutData.FieldClasses.Email
                              ? _vm.checkoutData.FieldClasses.Email
                              : "",
                          attrs: {
                            type: "email",
                            id: "email",
                            name: "email",
                            placeholder:
                              _vm.$resourceString[
                                "checkout.Address.Placeholder.ContactEmail"
                              ],
                            required: "",
                            maxlength: "45"
                          },
                          domProps: { value: _vm.inputAddress["email"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.inputAddress,
                                "email",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.validationError.email
                          ? _c("div", { staticClass: "text-danger font-16" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.validationError.email) +
                                  "\n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-6 col-12" }, [
                        _c(
                          "label",
                          { staticClass: "font-16 font-weight-bold mt-2" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$resourceString[
                                  "checkout.Address.Label.Phone"
                                ]
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-group position-relative mb-0",
                            attrs: { id: "checkout-form" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputAddress["cellPhone"],
                                  expression: "inputAddress['cellPhone']"
                                }
                              ],
                              staticClass:
                                "shipping-modal-input-field form-control text-box single-line",
                              class:
                                _vm.checkoutData.FieldClasses &&
                                _vm.checkoutData.FieldClasses.Phone
                                  ? _vm.checkoutData.FieldClasses.Phone
                                  : "",
                              attrs: {
                                type: "tel",
                                id: "phone",
                                name: "phone",
                                placeholder:
                                  _vm.$resourceString[
                                    "checkout.Address.Placeholder.Phone"
                                  ],
                                required: "",
                                minlength: "17",
                                maxlength: "20"
                              },
                              domProps: {
                                value: _vm.inputAddress["cellPhone"]
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.inputAddress,
                                    "cellPhone",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "custom-tooltip" }, [
                              _c("i", { staticClass: "tooltip-icon" }, [
                                _vm._v("?")
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "tooltip-text arrow-down" },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "checkout.Address.PhoneNumber.Tooltip"
                                        ]
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.validationError.cellPhone
                          ? _c("div", { staticClass: "text-danger font-16" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.validationError.cellPhone) +
                                  "\n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputAddress["isDefault"],
                              expression: "inputAddress['isDefault']"
                            }
                          ],
                          staticClass: "mt-2",
                          attrs: {
                            type: "checkbox",
                            id: "defaultaddresscheckbox",
                            name: "defaultaddress"
                          },
                          domProps: {
                            checked: Array.isArray(
                              _vm.inputAddress["isDefault"]
                            )
                              ? _vm._i(_vm.inputAddress["isDefault"], null) > -1
                              : _vm.inputAddress["isDefault"]
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.inputAddress["isDefault"],
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.inputAddress,
                                      "isDefault",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.inputAddress,
                                      "isDefault",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.inputAddress, "isDefault", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "mt-4 font-16 font-weight-bold",
                            attrs: { for: "defaultaddress" }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.Label.DefaultAddress"
                                  ]
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.mellisaValidationModal
                  ? _c("form", [
                      _vm.getMellisaValidation.status == "Changed"
                        ? _c("p", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.MellisaValidation.Changed"
                                  ]
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getMellisaValidation.status == "Invalid"
                        ? _c("p", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.MellisaValidation.InValid"
                                  ]
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-6 col-12" }, [
                          _c("p", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.MellisaValidation.OriginalAddress"
                                  ]
                                ) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-light p-3 font-24 text-capitalize",
                              class:
                                _vm.currentSelectedAddress == 0
                                  ? "border border-danger rounded"
                                  : "",
                              on: {
                                click: function($event) {
                                  return _vm.addressConfirmation(0)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "m-0" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.inputAddress.firstName) +
                                    "\n                    " +
                                    _vm._s(_vm.inputAddress.lastName) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "m-0" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.inputAddress.streetLine1) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "m-0" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.inputAddress.city) +
                                    "\n                    " +
                                    _vm._s(_vm.inputAddress.state) +
                                    "\n                    " +
                                    _vm._s(_vm.inputAddress.postalCode) +
                                    "\n                  "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "m-0" }, [
                                _vm._v(_vm._s(_vm.inputAddress.country))
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        this.getMellisaValidation.status != "Invalid"
                          ? _c("div", { staticClass: "col-lg-6 col-12" }, [
                              _c("p", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "checkout.Address.MellisaValidation.SuggestedAddress"
                                      ]
                                    ) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bg-light p-3 font-24 text-capitalize",
                                  class:
                                    _vm.currentSelectedAddress == 1
                                      ? "border border-danger rounded"
                                      : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.addressConfirmation(1)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "m-0" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.inputAddress.firstName) +
                                        "\n                    " +
                                        _vm._s(_vm.inputAddress.lastName) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "mb-1",
                                      class:
                                        _vm.inputAddress.streetLine1 !=
                                        _vm.getMellisaValidation.changedAddress
                                          .addressLine1
                                          ? "changed-address"
                                          : ""
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.getMellisaValidation
                                              .changedAddress.addressLine1
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mb-1" }, [
                                    _c(
                                      "span",
                                      {
                                        class:
                                          _vm.inputAddress.city !=
                                          _vm.getMellisaValidation
                                            .changedAddress.locality
                                            ? "changed-address"
                                            : ""
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.getMellisaValidation
                                                .changedAddress.locality
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        class:
                                          _vm.inputAddress.state !=
                                          _vm.getMellisaValidation
                                            .changedAddress.administrativeArea
                                            ? "changed-address"
                                            : ""
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.getMellisaValidation
                                                .changedAddress
                                                .administrativeArea
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        class:
                                          _vm.inputAddress.postalCode !=
                                          _vm.getMellisaValidation
                                            .changedAddress.postalCode
                                            ? "changed-address"
                                            : ""
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.getMellisaValidation
                                                .changedAddress.postalCode
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "m-0" }, [
                                    _c(
                                      "span",
                                      {
                                        class:
                                          _vm.inputAddress.country !=
                                          _vm.getMellisaValidation
                                            .changedAddress.country
                                            ? "changed-address"
                                            : ""
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.getMellisaValidation
                                                .changedAddress.country
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        !_vm.showSaveAddressButton
                          ? _c("p", { staticClass: "text-danger" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "checkout.Address.MellisaValidation.AddressError"
                                    ]
                                  ) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c("div", { staticClass: "w-100 row" }, [
                  _c("div", { staticClass: "col-6 d-none d-lg-block" }, [
                    !_vm.addClicked &&
                    !_vm.editClicked &&
                    !_vm.mellisaValidationModal
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wf-add-to-cart-button btn btn-outline-danger m-1",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.addressModalAction(0)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Button.AddNewAddress"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.addClicked || _vm.editClicked
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wf-add-to-cart-button btn btn-outline-danger m-1",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.showAddressList()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.AddressVerification.Modal.AddressList"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 col-12" }, [
                    !_vm.mellisaValidationModal
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wf-add-to-cart-button btn btn-primary m-1 col-md-6 col-12 justify-content-center",
                            attrs: { type: "button" },
                            on: { click: _vm.validateUserAddress }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.AddressVerification.Modal.ValidateButton"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.mellisaValidationModal
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wf-add-to-cart-button btn btn-danger m-1 col-md-5 col-12 justify-content-center",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: { click: _vm.exitNewModal }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Address.Button.CancelAddress"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mellisaValidationModal
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wf-add-to-cart-button btn btn-primary m-1 col-md-5 col-12 justify-content-center",
                            attrs: {
                              disabled: !_vm.showSaveAddressButton,
                              type: "button"
                            },
                            on: { click: _vm.saveAddress }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.AddressVerification.Suggestion.SaveButton"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mellisaValidationModal
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "wf-add-to-cart-button btn btn-primary m-1 col-md-6 col-12 justify-content-center",
                            attrs: { type: "button" },
                            on: { click: _vm.editAddress }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.AddressVerification.Suggestion.EditButton"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }